// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2rlRE","subheader":"ReorderModal_subheader__lL60z","listWrap":"ReorderModal_listWrap__2RSBp"};